import React from 'react';
import { Box, Tooltip, Typography, Switch } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import UploadIcon from '@mui/icons-material/Upload';

import FormInputCEditor from '../../../../form-components/FormInputCEditor';

import {
  CardsContainer,
  InfoCard,
  InfoCardTitle,
  AICardToggleBox,
  AIToggleLabel,
  AIToggleLabelWrapper,
  AIToggleIconWrapper,
  StyledSwitch,
  PhotoUploadLabelRow,
  PhotoUploadLabel,
  PhotoUploadHint,
  ImageUploadDropZone,
  ImageUploadDropZoneText,
  ImageThumbList,
  ImageThumb,
  ImageThumbImg,
  ImageThumbRemove,
  CurriculumPanel,
  CurriculumFieldGroup,
  CurriculumInputLine,
  CurriculumDescTextarea,
  CurriculumAddBox,
  CurriculumAddCurriculumButton,
  ClassDetailEditorBox,
  BottomActionsNew,
  CancelButtonNew,
  PrevButtonNew,
  SubmitButtonNew,
} from './TrialEditStyled';

function TrialEditStep02({
  control,
  watch,
  setValue,
  trialData,
  curriculumList,
  aiToggle,
  setAiToggle,
  uploadImages,
  deleteVoucher,
  handleCurriculumChange,
  handleCurriculumImageUpload,
  handleCurriculumImageDelete,
  addCurriculum,
  deleteCurriculum,
  onPrev,
  onSubmit,
  onCancel,
  loader,
  isEditMode,
  canSave = true,
  exposureYn,
  setExposureYn,
}) {
  const productType = watch('classType');
  const isLesson = productType === 'PRIVATE_LESSON' || productType === 'GROUP_LESSON' || productType === 'OT';

  // AI 토글은 현재 미사용
  // const renderAIToggle = () => (
  //   <AICardToggleBox>
  //     <AIToggleLabelWrapper>
  //       <AIToggleIconWrapper>
  //         <AutoAwesomeIcon sx={{ fontSize: 18 }} />
  //       </AIToggleIconWrapper>
  //       <AIToggleLabel>AI로 작성하기</AIToggleLabel>
  //     </AIToggleLabelWrapper>
  //     <StyledSwitch checked={aiToggle} onChange={e => setAiToggle(e.target.checked)} />
  //   </AICardToggleBox>
  // );

  return (
    <>
      <CardsContainer>
        {/* Card 1: 일일권 이미지 */}
        <InfoCard>
          <InfoCardTitle>일일권 이미지</InfoCardTitle>
          {/* {renderAIToggle()} */}

          <PhotoUploadLabelRow>
            <PhotoUploadLabel>사진 업로드</PhotoUploadLabel>
            <PhotoUploadHint>*최대 7장</PhotoUploadHint>
          </PhotoUploadLabelRow>

          {trialData.voucherList?.length > 0 && (
            <ImageThumbList>
              {trialData.voucherList.map((img, index) => (
                <ImageThumb key={index}>
                  <ImageThumbImg
                    src={img.voucherUrl ?? (window.URL || window.webkitURL).createObjectURL(img.voucherImg)}
                    alt={`이미지 ${index + 1}`}
                  />
                  <ImageThumbRemove onClick={() => deleteVoucher(index)}>
                    <CloseIcon sx={{ fontSize: 12 }} />
                  </ImageThumbRemove>
                </ImageThumb>
              ))}
            </ImageThumbList>
          )}

          {(trialData.voucherList?.length || 0) < 7 && (
            <ImageUploadDropZone>
              <UploadIcon sx={{ fontSize: 32 }} />
              <ImageUploadDropZoneText>이미지 업로드</ImageUploadDropZoneText>
              <input hidden accept="image/*" multiple type="file" onChange={uploadImages} />
            </ImageUploadDropZone>
          )}
        </InfoCard>

        {/* Card 2 (LESSON 전용): 커리큘럼 등록 */}
        {isLesson && (
          <InfoCard>
            <InfoCardTitle>커리큘럼 등록</InfoCardTitle>
            {/* {renderAIToggle()} */}

            {curriculumList.map((curriculum, index) => (
              <CurriculumPanel key={index}>
                <CurriculumFieldGroup>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <PhotoUploadLabel>제목</PhotoUploadLabel>
                    {curriculumList.length > 1 && (
                      <Box
                        onClick={() => deleteCurriculum(index)}
                        sx={{
                          cursor: 'pointer',
                          color: '#A6A6A6',
                          display: 'flex',
                          alignItems: 'center',
                        }}>
                        <CloseIcon sx={{ fontSize: 16 }} />
                      </Box>
                    )}
                  </Box>
                  <CurriculumInputLine
                    placeholder="제목을 입력해 주세요."
                    value={curriculum.title}
                    onChange={e => handleCurriculumChange(index, 'title', e.target.value)}
                  />
                </CurriculumFieldGroup>

                <CurriculumFieldGroup>
                  <PhotoUploadLabelRow>
                    <PhotoUploadLabel>사진 업로드</PhotoUploadLabel>
                    <PhotoUploadHint>*최대 7장</PhotoUploadHint>
                  </PhotoUploadLabelRow>
                  <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    {curriculum.images?.map((img, imgIndex) => (
                      <ImageThumb key={imgIndex}>
                        <ImageThumbImg
                          src={img.url ?? (window.URL || window.webkitURL).createObjectURL(img.file)}
                          alt={`커리큘럼 이미지 ${imgIndex + 1}`}
                        />
                        <ImageThumbRemove onClick={() => handleCurriculumImageDelete(index, imgIndex)}>
                          <CloseIcon sx={{ fontSize: 12 }} />
                        </ImageThumbRemove>
                      </ImageThumb>
                    ))}
                    {(!curriculum.images || curriculum.images.length < 7) && (
                      <CurriculumAddBox>
                        <AddIcon sx={{ fontSize: 24 }} />
                        <input
                          hidden
                          accept="image/*"
                          type="file"
                          onChange={e => handleCurriculumImageUpload(index, e)}
                        />
                      </CurriculumAddBox>
                    )}
                  </Box>
                </CurriculumFieldGroup>

                <CurriculumFieldGroup>
                  <PhotoUploadLabel>내용</PhotoUploadLabel>
                  <CurriculumDescTextarea
                    placeholder="내용을 입력해 주세요."
                    value={curriculum.description}
                    onChange={e => handleCurriculumChange(index, 'description', e.target.value)}
                  />
                </CurriculumFieldGroup>
              </CurriculumPanel>
            ))}

            {curriculumList.length < 5 && (
              <CurriculumAddCurriculumButton onClick={addCurriculum}>
                <AddIcon sx={{ fontSize: 18 }} />
                커리큘럼 추가
              </CurriculumAddCurriculumButton>
            )}
          </InfoCard>
        )}

        {/* Card 3: 상품 상세 */}
        <InfoCard>
          <InfoCardTitle>상품 상세</InfoCardTitle>
          {/* {renderAIToggle()} */}

          <PhotoUploadLabel>내용</PhotoUploadLabel>
          <ClassDetailEditorBox>
            <FormInputCEditor
              setValue={setValue}
              control={control}
              data={trialData?.classDetail ?? ''}
              name="classDetail"
            />
          </ClassDetailEditorBox>
        </InfoCard>
      </CardsContainer>

      {/* Bottom Buttons */}
      <BottomActionsNew>
        <CancelButtonNew onClick={onCancel}>취소</CancelButtonNew>
        <PrevButtonNew onClick={onPrev}>이전</PrevButtonNew>
        <Tooltip title={!canSave ? '권한이 없습니다' : ''} arrow>
          <span>
            <SubmitButtonNew onClick={onSubmit} disabled={loader || !canSave}>
              {isEditMode ? '저장' : '생성'}
            </SubmitButtonNew>
          </span>
        </Tooltip>
      </BottomActionsNew>
    </>
  );
}

export default TrialEditStep02;
